import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MbTabs from 'components/organisms/MbTabs';
import MainTemplate from 'pages/templates/MainTemplate';

import DocumentTable from './DocumentTable';

const Document = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="Document"
        tabMenuList={tabList()}
        tabs={{
          '/system/document/normal': {
            tabComponent: <DocumentTable division="main" />,
          },
          '/system/document/sysDoc': {
            tabComponent: <DocumentTable division="sub" />,
          },
        }}
      />
    </MainTemplate>
  );
};

export default Document;
